import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class LogoutErrorAction implements Action {
  public static readonly type = 'LogoutErrorAction';

  constructor(public error: BijbError) {
  }

  public type = LogoutErrorAction.type;
}
